import { _ as _define_property } from "@swc/helpers/_/_define_property";
import React from 'react';
import throttle from 'lodash/throttle';
const THROTTLE_TIMEOUT = 100;
class ElementQueries extends React.Component {
    componentDidMount() {
        this.setBreakpoints();
        window.addEventListener('resize', this.setBreakpoints);
    }
    componentWillUnmount() {
        window.removeEventListener('resize', this.setBreakpoints);
    }
    render() {
        const { id, children, width, className } = this.props;
        return /*#__PURE__*/ React.createElement("div", {
            id: id,
            ref: this.saveRootRef,
            "data-min-width": width && this.getMinWidthAttrValue(width),
            "data-max-width": width && this.getMaxWidthAttrValue(width),
            className: className
        }, children);
    }
    constructor(...args){
        super(...args);
        _define_property(this, "rootRef", void 0);
        _define_property(this, "saveRootRef", (node)=>{
            this.rootRef = node;
            const { forwardedRef } = this.props;
            if (forwardedRef) {
                if (typeof forwardedRef === 'function') {
                    forwardedRef(node);
                } else {
                    forwardedRef.current = node;
                }
            }
        });
        _define_property(this, "getMinWidthAttrValue", (elementWidth)=>{
            const minWidth = this.props.widthBreakpoints.filter((width)=>width <= elementWidth);
            return minWidth.join(' ');
        });
        _define_property(this, "getMaxWidthAttrValue", (elementWidth)=>{
            const maxWidth = this.props.widthBreakpoints.filter((width)=>width >= elementWidth);
            return maxWidth.join(' ');
        });
        _define_property(this, "setBreakpoints", throttle(()=>requestAnimationFrame(()=>{
                if (!this.rootRef) {
                    return;
                }
                const sizes = this.rootRef.getBoundingClientRect();
                this.rootRef.setAttribute('data-max-width', this.getMaxWidthAttrValue(sizes.width));
                this.rootRef.setAttribute('data-min-width', this.getMinWidthAttrValue(sizes.width));
                this.props.onSettled && this.props.onSettled();
            }), THROTTLE_TIMEOUT));
    }
}
export { ElementQueries as default };
